import Vue from 'vue';
import { 
  saveWatchList,
  getWatchList,
  requestVitalSignsCodes
} from '@/api/sessionApi';
import { clearAllWatches, setAllWatches,
  removeCheckedMeasure,addCheckedMeasure,
  removeMeasure, addMeasure,removeProcedure,
  addProcedure, addTrendCheckedMeasure, resetCheckedVitals } from '@/mutation-types';

const state = {
  // current items in the watch list
  procedures: {},     // procmeas: key: id of proc, value: hash set of meas id, e.g.: {412: {8123: true, 123: true ...}, ...} 
  measures: {},       // hash set of id, e.g.: {8123: true, 123: true ...}
  checkedMeasures: {}, // the ones that are in the graph: hash set of id, e.g.: {8123: true, 123: true ...}
  vitalSignCodes: [],
  externalMeasuresLoaded: false
};

const getters = {
  getProceduresWatching: state => state.procedures,
  getMeasuresWatching: state => state.measures,
  getCheckedMeasures: state => state.checkedMeasures,
  getVitalSignCodes: state => state.vitalSignCodes,
  areExternalMeasuresLoaded: state => state.externalMeasuresLoaded,
  getCheckedMeasuresOnly: state => {
    let result = {}
    Object.keys(state.checkedMeasures).forEach(meas => {
      if (!state.vitalSignCodes.includes(parseInt(meas)))
        result[meas] = true
    })
    return result
  },
  getCheckedVitalsOnly: state => {
    let result = {}
    Object.keys(state.checkedMeasures).forEach(meas => {
      if (state.vitalSignCodes.includes(parseInt(meas)))
        result[meas] = true
    })
    return result
  }
};

const mutations = {
  [resetCheckedVitals] (state) {
    Object.keys(state.checkedMeasures).forEach(meas => {
      if (state.vitalSignCodes.includes(parseInt(meas)))
        Vue.delete(state.checkedMeasures, meas)
    })
  },
  /**
   * Adds all of the proc's meas as a set to the watch list
   * @param {Object} procmeas {proc: procId, meas: arrayofMeasId}
   */
  [addProcedure] (state, procmeas) {
    Vue.set(state.procedures, procmeas.proc, procmeas.meas);
  },
  [removeProcedure] (state, cptCode) {
    Vue.delete(state.procedures, cptCode);
  },
  /**
   * @param {object} procmeas {proc: Number, meas: Number}
   */
  [addMeasure] (state, procmeas) {
    if (typeof procmeas.proc !== 'undefined' && procmeas.proc !== null) {
      if (!state.procedures[procmeas.proc]) {
        Vue.set(state.procedures, procmeas.proc, {});
      }
      Vue.set(state.procedures[procmeas.proc], procmeas.meas, true);
    } else {
      Vue.set(state.measures, procmeas.meas, true);
    }
    // Vue.set(state, 'newestProcedure', procmeas)
  },
  /**
   * @param {object} procmeas {proc: Number, meas: Number}
   */
  [removeMeasure] (state, procmeas) {
    if (typeof procmeas.proc !== 'undefined' && procmeas.proc !== null) {
      Vue.delete(state.procedures[procmeas.proc], procmeas.meas);
      // remove corresponding procedure if the meas is the only element
      if (Object.keys(state.procedures[procmeas.proc]).length === 0) {
        Vue.delete(state.procedures, procmeas.proc);
      }
    } else {
      Vue.delete(state.measures, procmeas.meas);
    }
  },
  [addCheckedMeasure] (state, measCcd) {
    // graph at most 2 measurements
    // if there are more than 2 measurements, clear all
    // if (Object.keys(state.checkedMeasures).includes('76633') && Object.keys(state.checkedMeasures).includes('77371')) {

    // }
    if (Object.keys(state.checkedMeasures).length === 2) {
      Vue.delete(state.checkedMeasures, Object.keys(state.checkedMeasures)[0]);
      Vue.delete(state.checkedMeasures, Object.keys(state.checkedMeasures)[0]);
    }
    Vue.set(state.checkedMeasures, measCcd, true);
  },
  [addTrendCheckedMeasure] (state, measCcd) {
    while (Object.keys(state.checkedMeasures).length != 0) {
      Vue.delete(state.checkedMeasures, Object.keys(state.checkedMeasures)[0])
    }
    Vue.set(state.checkedMeasures, measCcd, true)
  },
  [removeCheckedMeasure] (state, measCcd) {
    Vue.delete(state.checkedMeasures, measCcd);
  },
  [clearAllWatches] (state) {
    Vue.set(state, 'procedures', {});
    Vue.set(state, 'measures', {});
    Vue.set(state, 'checkedMeasures', {});
    Vue.set(state, 'externalMeasuresLoaded', false);
  },
  [setAllWatches](state,watchInfo) {
    let info =
      typeof watchInfo === "string" 
        ? JSON.parse(watchInfo) 
        : watchInfo;
    if (!info) return;
    state.procedures = info.procedures;
    state.measures = info.measures;
    state.checkedMeasures = info.checkedMeasures;
    // state.externalMeasuresLoaded = info.externalMeasuresLoaded;
  },
  setVitalSignCodes(state,vitalSignCodes) {
    Vue.set(state,'vitalSignCodes',vitalSignCodes);
  },
  setExternalMeasuresLoaded(state, trueOfFalse) {
    state.externalMeasuresLoaded = trueOfFalse;
  }
};

const actions = {
  async saveWatches({state}) {
    let allData = {
      measures : state.measures,
      procedures : state.procedures,
      checkedMeasures : state.checkedMeasures
    };
    let text = JSON.stringify(allData);
    await saveWatchList(text);
  },

  setVitalSignCodes({commit}, vitalSignCodes) {
    commit('setVitalSignCodes', vitalSignCodes);
  },

  addProcedure({rootGetters, commit, state, dispatch}, cptCode) {
    // get all instances of proc with same code
    const procIds = rootGetters['login/getAllData'].cptprocs[cptCode];
    const procmeas = rootGetters['login/getAllData'].procmeas;
    const measures = rootGetters['login/getAllData'].measures;
    let measCcds = {};

    /** 
      Construct an object of cpt with all of its unique meas ccd from all 
      instances.
      This is to address the issue where different instances of the same 
      procedure having different measures
     */
    procIds.forEach(procId => {
      const measIds = procmeas[procId];
      if (measIds) {
        measIds.forEach(measId => {
          const measCcd = measures[measId].ccd;
          if (!measCcds.hasOwnProperty(measCcd)) {
            measCcds[measCcd] = true;
          }
        });
      }

    });

    commit('addProcedure', {proc: cptCode, meas: measCcds});
    dispatch('login/watch/saveWatches',null,{root:true});
  },
  resetCheckedVitals({commit, state, dispatch}){
    commit('resetCheckedVitals')
    dispatch('login/watch/saveWatches',null,{root:true})
  },
  async removeProcedure({commit,state, dispatch}, cptCode) {
    commit('removeProcedure', cptCode);
    await dispatch('login/watch/saveWatches',null,{root:true});
  },
  addMeasure({commit,state, dispatch}, procmeas) {
    commit('addMeasure', procmeas);
    dispatch('login/watch/saveWatches',null,{root:true});
  },
  async removeMeasure({commit,state, dispatch}, procmeas) {
    commit('removeMeasure', procmeas);
    await dispatch('login/watch/saveWatches',null,{root:true});
  },
  async addCheckedMeasure({commit,state, dispatch}, measCcd) {
    commit('addCheckedMeasure', measCcd);
    await dispatch('login/watch/saveWatches',null,{root:true});
  },
  async addTrendCheckedMeasure({commit, state, dispatch}, measCcd) {
    commit('addTrendCheckedMeasure', measCcd)
    await dispatch('login/watch/saveWatches', null, {root:true})
  },
  async removeCheckedMeasure({commit,state, dispatch}, measCcd) {
    commit('removeCheckedMeasure', measCcd);
    await dispatch('login/watch/saveWatches',null,{root:true});
  },
  clearAllWatches({commit}) {
    commit(clearAllWatches);
  },
  setExternalMeasuresLoaded({commit}, trueOfFalse) {
    commit('setExternalMeasuresLoaded', trueOfFalse);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
